import type { OrderStatus } from '@aggregator/shared';
import { Badge } from '@/components/ui/badge';

const MAP: Record<OrderStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' }> = {
  awaiting_payment: { label: 'Awaiting payment', variant: 'secondary' },
  verifying_payment: { label: 'Verifying payment', variant: 'warning' },
  pending: { label: 'Pending', variant: 'secondary' },
  processing: { label: 'Processing', variant: 'warning' },
  completed: { label: 'Completed', variant: 'success' },
  failed: { label: 'Failed', variant: 'destructive' },
  cancelled: { label: 'Cancelled', variant: 'destructive' },
  refunded: { label: 'Refunded', variant: 'default' },
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  const cfg = MAP[status];
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}
